import { useState } from 'react';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../translations';
import { MedicalConsentAndAuthorizationPrintModal } from '../MedicalConsentAndAuthorizationsPrintModal/MedicalConsentAndAuthorizationsPrintModal';

type MedicalConsentAndAuthorizationsPrintActionProps = {
   readonly patient: Patient;
};

const MedicalConsentAndAuthorizationsPrintAction = (
   props: MedicalConsentAndAuthorizationsPrintActionProps
): JSX.Element => {
   const [showModal, setShowModal] = useState(false);

   const openModal = (): void => {
      setShowModal(true);
   };

   const closeModal = (): void => {
      setShowModal(false);
   };

   return (
      <>
         <ActionBar.PrimaryButton
            testId={'printConsentsAndAuthorizations'}
            label={patientConsentsAndAuthorizationsTranslationKeys.printModal.printAction}
            onClick={openModal}
            variant={ButtonVariant.PRIMARY}
         />
         {showModal ? (
            <MedicalConsentAndAuthorizationPrintModal closeModal={closeModal} patient={props.patient} />
         ) : null}
      </>
   );
};

export { MedicalConsentAndAuthorizationsPrintAction };
